import React, { Fragment } from 'react';
import InputField from '../../Reusable/InputField';
import AmountInputField from '../../Reusable/AmountInputField';
import { emailRegex } from '../../../utils/regex.js';
import { useSelector } from 'react-redux';

const InputFieldDemo = () => {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [emailError, setEmailError] = React.useState('');
  const [passwordError, setPasswordError] = React.useState('');
  const translation = useSelector(
    (state) => state.translationsReducer.translations.Login.Form
  );

  const onChangeHandler = () => {};
  const onEmailChangeHandler = (event) => {
    const { value } = event.target;
    setEmail(value);
    if (emailRegex.test(value)) {
      setEmailError('');
    }
  };

  const passwordValidationHandler = (value) => {
    if (value.length < 5) {
      setPasswordError(translation.Errors.password);
    } else {
      setPasswordError('');
    }
  };

  const passwordMinLength = 4;

  const onPasswordChangeHandler = (event) => {
    const { value } = event.target;
    setPassword(value);
    if (value.length > passwordMinLength) {
      setPasswordError('');
    }
  };

  const onEmailBlurHandler = (event) => {
    const { value } = event.target;
    if (emailRegex.test(value)) {
      setEmailError('');
    } else {
      setEmailError(translation.Errors.email);
    }
  };

  const onPasswordBlurHandler = (event) => {
    const { value } = event.target;
    passwordValidationHandler(value);
  };

  return (
    <Fragment>
      <InputField
        id="smaller-input"
        name="smaller-input"
        className="smaller-input"
        placeholder={'small input'}
        onChange={onChangeHandler}
      />
      <InputField
        id="default-input"
        name="default-input"
        placeholder={'default input'}
        onChange={onChangeHandler}
      />
      <InputField
        id="large-input"
        name="large-input"
        placeholder={'large input'}
        onChange={onChangeHandler}
        size={'normal'}
      />
      <InputField
        id="multiline-input"
        name="multiline-input"
        placeholder={'multiline input'}
        onChange={onChangeHandler}
        multiline={true}
        rows={2}
      />
      <InputField
        id="disabled-input"
        name="disabled-input"
        placeholder={'disabled input'}
        value={'Lorem ipsum'}
        disabled
      />
      <InputField
        id="read-only-input"
        name="read-only-input"
        placeholder={'read-only input'}
        value={'Lorem ipsum'}
        readOnly
      />
      <InputField
        id="number-input"
        name="number-input"
        placeholder={'number input'}
        inputPlaceholder={'0123456789'}
        onChange={onChangeHandler}
        type="number"
        tooltipText="Postoji i mogućnost ograničenja na pozitivne brojeve"
      />
      <InputField
        id="email-input"
        name="email-input"
        placeholder={'email input'}
        inputPlaceholder={'example@dex.rs'}
        onChange={onEmailChangeHandler}
        type="email"
        value={email}
        error={emailError}
        onBlur={onEmailBlurHandler}
      />
      <AmountInputField
        id="currency-input"
        name="currency-input"
        placeholder={'currency input'}
        onChange={onChangeHandler}
        value={123456}
      />
      <InputField
        id="password"
        name="password"
        type="password"
        placeholder={'Password'}
        onChange={onPasswordChangeHandler}
        value={password}
        error={passwordError}
        onBlur={onPasswordBlurHandler}
      />
      <InputField
        id="clearable-input"
        name="clearable-input"
        placeholder={'Clearable input'}
        onChange={onChangeHandler}
        clearable
      />
    </Fragment>
  );
};

export default InputFieldDemo;
